import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'vg-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CardComponent {}
